const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

function headers() {
  return {
    'apikey': SUPABASE_KEY,
    'Authorization': 'Bearer ' + SUPABASE_KEY,
    'Content-Type': 'application/json'
  };
}

async function parseRpc(response, label) {
  const text = await response.text();

  if (!response.ok) {
    throw new Error(
      `${label} failed (${response.status}): ${text || response.statusText}`
    );
  }

  return text ? JSON.parse(text) : null;
}

function buildMasterSession(result) {
  const student = result?.student;
  if (!student?.id || !result?.token || !result?.expires_at) {
    return null;
  }

  const session = {
    studentId: student.id,
    studentCode: student.student_code,
    englishName: student.english_name,
    chineseName: student.chinese_name,
    email: student.email,
    isMaster: true,
    testingMode: true,
    masterSessionToken: result.token,
    expiresAt: new Date(result.expires_at).getTime()
  };

  localStorage.setItem('studentSession', JSON.stringify(session));
  return session;
}

export async function tryMasterStudentId(code) {
  const normalized = String(code || '').trim();

  if (!/^\d{6}$/.test(normalized)) {
    return null;
  }

  const response = await fetch(
    `${SUPABASE_URL}/rest/v1/rpc/consume_master_login_id`,
    {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ p_code: normalized })
    }
  );

  const result = await parseRpc(response, 'Checking Master Student ID');

  if (!result?.ok) {
    if (
      result?.status === 'invalid_code' ||
      result?.status === 'locked_code'
    ) {
      return null;
    }

    throw new Error(
      result?.message || 'Master Student login could not be started.'
    );
  }

  const session = buildMasterSession(result);

  if (!session) {
    throw new Error('Master Student login returned an invalid session.');
  }

  return session;
}

export async function restoreMasterStudentSession(savedSession) {
  const token = String(savedSession?.masterSessionToken || '').trim();

  if (!token) {
    return null;
  }

  let response;
  try {
    response = await fetch(
      `${SUPABASE_URL}/rest/v1/rpc/master_student_session_from_token`,
      {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ p_token: token })
      }
    );
  } catch (err) {
    throw new Error(
      'The app could not connect to verify the Master Student session.'
    );
  }

  const result = await parseRpc(response, 'Restoring Master Student');

  if (!result?.ok) {
    localStorage.removeItem('studentSession');
    return null;
  }

  return buildMasterSession(result);
}

export async function revokeMasterStudentSession(session) {
  const token = String(session?.masterSessionToken || '').trim();

  if (token) {
    try {
      await fetch(
        `${SUPABASE_URL}/rest/v1/rpc/revoke_master_student_session`,
        {
          method: 'POST',
          headers: headers(),
          body: JSON.stringify({ p_token: token })
        }
      );
    } catch (err) {
      console.error('Revoking Master Student session failed:', err);
    }
  }

  localStorage.removeItem('studentSession');
}